import { fonts } from "../../../styles/fonts";
import { colors } from "../../../styles/colors";

const fitnessPlanOuterContainer = {
    margin: 30
};

const fitnessActions: any = {
    display: "flex",
    justifyContent: "flex-end",
    padding: "12px 20px",
    background: colors.white,
    borderRadius: 0,
    boxShadow: "0px 0px 13px 0px rgba(0, 0, 0, 0.15)",
    position: "sticky",
    left: 0,
    bottom: 0,
    width: "100%"
}

const secondaryButton = {
    marginRight: 20,
    alignSelf: "center",
    cursor: "pointer"
}

const secondaryButtonText = {
    marginLeft: 7,
    color: colors.fuschiaPink,
    fontFamily: fonts.mediumFont,
    fontSize: 14
}

const buttonStyles = {
    display: "inline",
    fontSize: 14,
    padding: "10px 50px",
    marginTop: "4px"
}

const cancelButtonStyles = {
    ...buttonStyles,
    border: "1px solid rgb(255, 46, 99)",
    color: colors.fuschiaPink,
    padding: "10px 42px"
}

export {
    fitnessPlanOuterContainer,
    fitnessActions,
    buttonStyles,
    secondaryButtonText,
    secondaryButton,
    cancelButtonStyles
};